module.exports = __webpack_public_path__ + "img/3.64988a78.svg";